import React from 'react';
import Navbar from '../components/Navbar';
import HeroOption2 from '../components/HeroOption2';
import BookingSection from '../components/BookingSection';
import FloorplanSection from '../components/FloorplanSection';
import FeaturesSection from '../components/FeaturesSection';
import Reviews from '../components/Reviews';
import HostSection from '../components/HostSection';
import LocationSection from '../components/LocationSection';
import LocalGuideSection from '../components/LocalGuideSection';
import FAQSection from '../components/FAQSection';
import Footer from '../components/Footer';
import { propertyData } from '../data/mockData';

const PropertyPage = () => {
  return (
    <div className="min-h-screen bg-background animate-fade-in">
      <Navbar />
      
      {/* Main content - NO top padding for full-screen hero */}
      <main>
        {/* Split Hero Section with Logo Left, Images Right */}
        <HeroOption2 property={propertyData} />
        
        {/* Booking Widget Section */}
        <section className="animate-fade-in-up" style={{ animationDelay: '0.1s', animationFillMode: 'both' }}>
          <BookingSection property={propertyData} />
        </section>
        
        {/* Guest Reviews Section */}
        <section className="animate-fade-in-up" style={{ animationDelay: '0.2s', animationFillMode: 'both' }}>
          <Reviews property={propertyData} />
        </section>
        
        {/* Host Section - About Susanna */}
        <section className="animate-fade-in-up" style={{ animationDelay: '0.3s', animationFillMode: 'both' }}>
          <HostSection property={propertyData} />
        </section>
        
        {/* Susanna's Local Guide Section - Right after Host */}
        <section className="animate-fade-in-up" style={{ animationDelay: '0.35s', animationFillMode: 'both' }}>
          <LocalGuideSection />
        </section>
        
        {/* Location Map Section - Where you'll be */}
        <section className="animate-fade-in-up" style={{ animationDelay: '0.4s', animationFillMode: 'both' }}>
          <LocationSection />
        </section>
        
        {/* Floorplan & Perfect For Section */}
        <section className="animate-fade-in-up" style={{ animationDelay: '0.45s', animationFillMode: 'both' }}>
          <FloorplanSection property={propertyData} />
        </section>
        
        {/* Features Section - "Why Stay With Us" */}
        <section className="animate-fade-in-up" style={{ animationDelay: '0.5s', animationFillMode: 'both' }}>
          <FeaturesSection property={propertyData} />
        </section>
        
        {/* FAQ Section with Schema Markup */}
        <section className="animate-fade-in-up" style={{ animationDelay: '0.55s', animationFillMode: 'both' }}>
          <FAQSection />
        </section>
      </main>
      
      <section className="animate-fade-in-up" style={{ animationDelay: '0.6s', animationFillMode: 'both' }}>
        <Footer />
      </section>
    </div>
  );
};

export default PropertyPage;